<template>
  <section class="blog-hero-new" :style="sectionStyles">
    <div class="container">
      <div class="hero-content">
        <h1 class="hero-title" v-html="shopifyData.heroTitle" />
        <p class="hero-subtitle">
          <span class="hero-subtitle-lead">{{ subtitleParts[0] }}</span>
          <span v-if="subtitleParts[1]" class="hero-subtitle-body">{{ subtitleParts[1] }}</span>
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  // name: 'RenderBlogBlogHeroNew',
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    sectionStyles() {
      return {
        backgroundColor: this.shopifyData.bgColor || '#fff',
        paddingTop:
          window.innerWidth > 768
            ? (this.shopifyData.deskPaddingTop || '80') + 'px'
            : (this.shopifyData.mobPaddingTop || '60') + 'px',
        paddingBottom:
          window.innerWidth > 768
            ? (this.shopifyData.deskPaddingBottom || '40') + 'px'
            : (this.shopifyData.mobPaddingBottom || '30') + 'px',
      };
    },

    // Splits the subtitle on the first colon to allow different styling
    subtitleParts() {
      const str = this.shopifyData.heroSubtitle || '';
      const idx = str.indexOf(':');
      if (idx === -1) return [str, ''];
      return [str.slice(0, idx + 1), str.slice(idx + 1).trim()];
    },
  },
  mounted() {
    if (this.shopifyData.mode == 'true') {
      document.body.classList.add('landscape');
    }
  },
};
</script>

<style scoped>
.blog-hero-new {
  text-align: center;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.hero-content {
  max-width: 800px;
  margin: 0 auto;
}

.hero-title {
  color: #000;
  text-align: center;
  font-family: 'Helvetica Neue', serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  margin-bottom: 45px;
  text-transform: uppercase;
}

.hero-subtitle {
  color: #000;
  text-align: left;
  font-family: adobe-caslon-pro, sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  max-width: 600px;
  margin: 0 auto;
  gap: 14px;
  display: flex;
  flex-direction: column;
}

.hero-subtitle-lead {
  display: block;
  font-family: 'Big Caslon', serif;
  font-size: 45px;
  font-weight: 500;
  line-height: 100%;
}

/* body text after the colon */
.hero-subtitle-body {
  display: block;
  font-family: adobe-caslon-pro, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
}

@media (max-width: 1024px) {
  .container {
    padding: 0 30px;
  }

  .hero-subtitle {
    font-size: 17px;
    max-width: 500px;
  }
}

@media (max-width: 768px) {
  .container {
    padding: 0 20px;
  }

  .hero-title {
    margin-bottom: 60px;
  }

  .hero-subtitle {
    font-size: 16px;
    max-width: 100%;
  }
}

@media (max-width: 480px) {
  .container {
    padding: 0 15px;
  }

  .hero-subtitle {
    font-size: 15px;
    line-height: 140%;
  }
}
</style>
